import React, { Component } from 'react'
import { MDBCol, MDBIcon } from 'mdb-react-ui-kit'

import './TrainingAnswer.scss'

class TrainingAnswer extends Component {
  state = {
    answer: null,
  }

  componentDidMount() {
    this.setState({
      answer: this.props.answer,
    })
  }

  clickHandle = event => {
    this.props.onClickAnswer(this.state.answer)
  }

  render() {
    const isSelected = this.props.answer?.checked
    const isSubmitted = this.props.submitted
    const isCorrect = !!this.props.answer?.is_correct
    const isMultiple = this.props.isMultiple
    const isReadOnly = isSubmitted || !!this.props.locked

    let submittedClass = ''
    if (isSubmitted && isSelected) {
      submittedClass = isCorrect ? ' correct' : ' incorrect'
    }

    const renderIcon = () => {
      if (isSubmitted) {
        if (isSelected && isCorrect) return <MDBIcon icon='check-circle' />
        if (isSelected && !isCorrect) return <MDBIcon icon='times-circle' />
        return <MDBIcon far icon={isMultiple ? 'square' : 'circle'} />
      }
      if (isSelected) return <MDBIcon icon={isMultiple ? 'check-square' : 'check-circle'} />
      return <MDBIcon far icon={isMultiple ? 'square' : 'circle'} />
    }

    return (
      <MDBCol className='mb-2' size='12'>
        <div
          className={`quiz-answer-option${isSelected ? ' selected' : ''}${isSubmitted ? ' submitted' : ''}${
            this.props.locked ? ' locked' : ''
          }${submittedClass}`}
          onClick={isReadOnly ? undefined : evt => this.clickHandle(evt)}
          role='button'
          aria-disabled={isReadOnly}
          tabIndex={isReadOnly ? -1 : 0}
        >
          <span className='answer-radio'>{renderIcon()}</span>
          <span className='answer-text'>{this.props.answer?.label}</span>
        </div>
      </MDBCol>
    )
  }
}

export default TrainingAnswer
